import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';

export const Invitation = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  justify: 'space-between',
  backgroundColor: 'primaryBase',
  marginBottom: '15px',
  padding: '5px 20px',
  color: 'background',
})`
  border-radius: 5px;
`;

export const NotificationDeclineButton = styled(Button).attrs({
  btnType: 'invisible',
})`
  color: ${({ theme }) => theme.colors.background};
  :hover {
    color: ${({ theme }) => theme.colors.primaryText};
    background-color: transparent;
  }
`;

export const NotificationAcceptButton = styled(Button).attrs({
  btnType: 'secondary',
})`
  color: ${({ theme }) => theme.colors.primaryText};
  background-color: ${({ theme }) => theme.colors.foreground};
  :hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;
